import { AlertIcon, CheckCircleIcon, WarningIcon } from 'Asset/icon';
import React from 'react';

export const getColor = ({ status }) => {
  const defaultColor = {
    borderColor: 'var(--color-error60)',
    backgroundColor: 'var(--color-error10)',
    icon: <WarningIcon color="var(--color-error60)" size="14px" />,
  };

  const obj = {
    error: {
      borderColor: 'var(--color-error60)',
      backgroundColor: 'var(--color-error10)',
      textColor: 'var(--color-error80)',
      icon: <WarningIcon color="var(--color-error60)" size="14px" />,
    },
    failed: {
      borderColor: 'var(--color-error60)',
      backgroundColor: 'var(--color-error10)',
      textColor: 'var(--color-error80)',
      icon: <WarningIcon color="var(--color-error60)" size="14px" />,
    },
    success: {
      borderColor: 'var(--color-success60)',
      backgroundColor: 'var(--color-success10)',
      textColor: 'var(--color-success80)',
      icon: <CheckCircleIcon color="var(--color-success60)" />,
    },
    loading: {
      borderColor: 'var(--color-info60)',
      backgroundColor: 'var(--color-info10)',
      textColor: 'var(--color-info80)',
      icon: <AlertIcon color="var(--color-info60)" />,
    },
    syncSuccess: {
      borderColor: 'var(--color-success60)',
      backgroundColor: 'var(--color-success10)',
      textColor: 'var(--color-success80)',
      icon: <CheckCircleIcon color="var(--color-success60)" size="18px" />,
    },
  };

  return obj[status] || defaultColor;
};
